(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-nuestra-comunidad"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function inicializarCarruselComunidad(carrusel) {
      var pista = carrusel.querySelector('.seccion-comunidad-pista');
      var diapositivasOriginales = Array.prototype.slice.call(carrusel.querySelectorAll('.seccion-comunidad-diapositiva'));

      if (diapositivasOriginales.length === 0) {
        return;
      }

      var totalOriginal = diapositivasOriginales.length;
      var velocidadSegundos = parseFloat(carrusel.getAttribute('data-velocidad')) || 3;
      var columnasEscritorio = parseInt(carrusel.getAttribute('data-columnas-escritorio'), 10) || 3;
      var columnasMovil = parseInt(carrusel.getAttribute('data-columnas-movil'), 10) || 1;

      diapositivasOriginales.forEach(function (diapositiva) {
        var clon = diapositiva.cloneNode(true);
        clon.setAttribute('aria-hidden', 'true');
        pista.appendChild(clon);
      });

      var indiceActual = 0;
      var columnasVisibles = columnasEscritorio;
      var temporizador = null;
      var enTransicion = false;

      function obtenerColumnasVisibles() {
        return window.matchMedia('(min-width: 990px)').matches ? columnasEscritorio : columnasMovil;
      }

      function establecerAnchoDiapositivas() {
        columnasVisibles = obtenerColumnasVisibles();
        var ancho = 100 / columnasVisibles;
        var todasLasDiapositivas = carrusel.querySelectorAll('.seccion-comunidad-diapositiva');
        todasLasDiapositivas.forEach(function (diapositiva) {
          diapositiva.style.width = ancho + '%';
        });
      }

      function moverA(indice, conTransicion) {
        var ancho = 100 / columnasVisibles;
        pista.style.transition = conTransicion ? 'transform 0.6s ease' : 'none';
        pista.style.transform = 'translateX(-' + (indice * ancho) + '%)';
      }

      function avanzar() {
        if (enTransicion) {
          return;
        }
        enTransicion = true;
        indiceActual += 1;
        moverA(indiceActual, true);

        if (indiceActual >= totalOriginal) {
          window.setTimeout(function () {
            indiceActual = 0;
            moverA(indiceActual, false);
            enTransicion = false;
          }, 600);
        } else {
          window.setTimeout(function () {
            enTransicion = false;
          }, 600);
        }
      }

      function iniciarAutoplay() {
        detenerAutoplay();
        temporizador = window.setInterval(avanzar, velocidadSegundos * 1000);
      }

      function detenerAutoplay() {
        if (temporizador) {
          window.clearInterval(temporizador);
          temporizador = null;
        }
      }

      establecerAnchoDiapositivas();
      moverA(0, false);
      iniciarAutoplay();

      window.addEventListener('resize', function () {
        establecerAnchoDiapositivas();
        moverA(indiceActual, false);
      });

      carrusel.addEventListener('mouseenter', detenerAutoplay);
      carrusel.addEventListener('mouseleave', iniciarAutoplay);
    }

    document.querySelectorAll('.seccion-comunidad-carrusel').forEach(function (carrusel) {
      inicializarCarruselComunidad(carrusel);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
